export class ClientLenderConfigurationSearchRequest {
    ClientId?: number | null;
    TwilioIntegrationId?: number | null;
    ClientName?: string | null;
    LenderName?: string | null;
    AccountSid?: string | null;
    MessagingServiceSid?: string | null;
    CallbackUrlKey?: string | null;
    AuthToken?: string | null;
    LenderOutboundWebhookUrl?: string | null;
    LenderInboundWebhookUrl?: string | null;
    IsDisabled?: boolean | null;
}
